import axios from "axios";
import setAuthToken from "../functions/auth_header";
import { getAppUrl, getLocationApiUrl } from "../functions/getEnv";

let brandDomains = {};

// Helper function to wait
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const fetchBrands = async (retries = 5, delay = 5000) => {
	const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);
	const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

	for (let i = 0; i < retries; i++) {
		try {
			const authResponse = await axios.get(`${appUrl}/auth/webapp`);
			const userAccessToken = authResponse.data.accessTokens;
			setAuthToken(userAccessToken);

			const response = await axios.get(`${locationApiUrl}/domain`);
			const brands = response.data;

			if (Array.isArray(brands) && brands.length > 0) {
				const brandVariables = brands.reduce((acc, brand) => {
					const sanitizedKey = `brand_${brand.brandName.toLowerCase().replace(/[^a-z0-9]/g, "_")}`;
					acc[sanitizedKey] = {
						name: brand.brandName,
						domain: brand.domain,
						brandIcon: brand.brandIcon,
						brandPhoto: brand.brandPhoto
					};
					return acc;
				}, {});

				brandDomains = {
					brand_stanza: brandVariables.brand_stanza,
					brand_learn4life: brandVariables.brand_learn4life,
					brand_elev8: brandVariables.brand_elev8,
					brand_flexhigh: brandVariables.brand_flex_high,
					brand_holston: brandVariables.brand_holston,
					brand_llac: brandVariables.brand_llac,
					brand_pbia: brandVariables.brand_palm_beach_international,
				};

				return brandDomains;
			} else {
				console.log("No brands found in the response.");
				return {}; // Return empty object if no brands
			}

		} catch (error) {
			const isLastAttempt = i === retries - 1;

			if (isLastAttempt) {
				console.error("Error fetching brands after multiple attempts:", error);
				throw error;
			}

			console.log(`Backend connection failed (Attempt ${i + 1}/${retries}). Retrying in ${delay}ms...`);
			await wait(delay);
		}
	}
};

export { fetchBrands, brandDomains };
